import styled, { css } from 'styled-components/macro'

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';

const {
  colors: { color },
  mediaqueries: { tabletPortraitDown },
  sizing: { spacingsize },
} = settings;

const {
  layout: { pageSectionInner },
  typography: { heading1, heading2, heading3, heroDescription },
} = mixins;

export const MarkdownContainer = styled.div`
  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.isSection) && css`
    ${pageSectionInner}
  `}

  ${(props) => (props.backgroundColor) && css`
    background-color: ${color(props.backgroundColor)};
  `}
  /* stylelint-enable */

  h1 {
    ${heading1}
  }

  h2 {
    ${heading2}
  }

  h3 {
    ${heading3}
  }

  p {
    ${heroDescription}
  }

  ol {
    ${heroDescription}
    margin: 0 0 1.5rem;
    padding: 0;
    counter-reset: item;

    li {
      margin-top: ${spacingsize(5)};

      &:before {
        ${heading2}
        font-weight: bold;
        color: #69c8c6;
      }
    }

    &>li {
      padding: 0 0 0 2rem;
      list-style-type: none;
      counter-increment: item;

      &:before {
        display: inline-block;
        padding-right: 0.5rem;
        font-weight: bold;
        text-align: right;
        content: counter(item) ".";
      }

      @media ${tabletPortraitDown} {
        padding-left: 0;
      }
    }
  }
`;